import React from "react";
import PageHeader from "../components/PageHeader";
import { WHY_US } from "../data/content";

const WhyUs = () => {
  return (
    <div data-testid="why-us-page">
      <PageHeader
        eyebrow="Why Worldly Solutions"
        title={<>Five reasons leaders <em className="text-brand-green font-serif italic">choose us.</em></>}
        subtitle="Built on trust, transparency and tangible results — the qualities our clients consistently come back to."
      />

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="space-y-24">
            {WHY_US.map((p, i) => (
              <div key={p.num} data-testid={`why-us-${i}`} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="lg:col-span-5">
                  <div className="relative aspect-[4/5] rounded-sm overflow-hidden">
                    <img src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/40 to-transparent" />
                    <div className="absolute top-6 left-6 font-serif text-5xl text-white">{p.num}</div>
                  </div>
                </div>
                <div className="lg:col-span-7">
                  <div className="text-xs font-bold tracking-[0.25em] uppercase text-brand-gold mb-4">Pillar {p.num}</div>
                  <h3 className="font-serif text-4xl md:text-5xl text-brand-ink tracking-tight leading-[1.05]">{p.title}</h3>
                  <p className="mt-6 text-brand-slate text-lg leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyUs;
